import { MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputBase from "@mui/material/InputBase";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";

export const SelectInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    position: "relative",
    border: "1px solid var(--color-gray-light)",
    fontSize: "0.875rem",
    padding: "0.25rem 0.5rem",
    "&:focus": {
      outline: "1px solid var(--color-gray-dark)",
      borderColor: "transparent",
    },
    background: "#fff",
  },
}));

function CustomSelectComponent({ name, id, onChange, placeholder, value, required, options, full = false, disabled = false }: { name: any; id: any; onChange: any; placeholder: any; value: any; required?: any; options: any; full?: boolean; disabled?: any; [key: string]: any }) {
  return (
    <FormControl sx={{ minWidth: "15rem", flex: full ? "1 1 0" : "0 0 auto" }} size="small">
      <Select
        name={name}
        id={id}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        required={required}
        input={<SelectInput />}
        displayEmpty
        sx={{ fontSize: "0.875rem" }}
        renderValue={(selected) => (selected ? selected : placeholder)}
        disabled={disabled}
      >
        {options &&
          options.length > 0 &&
          options.map((option) => (
            <MenuItem value={option.value} key={option.value} sx={{ fontSize: "0.875rem" }}>
              {option.label}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

export default CustomSelectComponent;
